import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../config';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Check if user is already logged in
    const token = localStorage.getItem('token');
    if (token) {
      // Parse JWT token to get user info
      try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        const { email, permissions, exp } = JSON.parse(jsonPayload);

        // Check if token is expired
        if (exp * 1000 < Date.now()) {
          localStorage.removeItem('token');
          setUser(null);
        } else {
          setUser({ token, email, permissions });
        }
      } catch (error) {
        console.error('Error parsing token:', error);
        localStorage.removeItem('token');
        setUser(null);
      }
    }
    setLoading(false);
  }, []);

  const login = async (credentialResponse) => {
    try {
      setError(null);
      console.log('Attempting login with credential:', credentialResponse.credential);

      const response = await api.post('/auth/google', {
        credential: credentialResponse.credential
      });

      console.log('Login response:', response.data);
      const { token, email, permissions } = response.data;
      localStorage.setItem('token', token);
      setUser({ token, email, permissions });
      return true;
    } catch (error) {
      console.error('Login error:', error);
      if (error.response?.status === 403) {
        setError('You are not authorized to access this application. Please contact your administrator.');
      } else {
        setError('An error occurred during login. Please try again.');
      }
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
    setError(null);
  };

  const value = {
    user,
    loading,
    error,
    login,
    logout,
    isAuthenticated: !!user
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};